import SelectSubAccountDropdown from '../../../../components/global-components/selectSubAccountDropdown';
import { Button, DropdownTemp } from '../../../../components';
import { carrierModes } from '../../constants';
import { useQuoteHistoryReport } from '../../hooks';
import DateRangePicker from '../DateRangePicker';
import Loading from '../Loading';

interface Props {
  isAdmin: boolean;
}

export default function QuoteHistoryReportFilters({ isAdmin }: Props) {
  const {
    isLoading,
    startDate,
    endDate,
    onChangeShippedDates,
    account,
    onChangeAccount,
    carrierMode,
    onChangeCarrierMode,
    clearFilters,
    onClickDownload,
  } = useQuoteHistoryReport(isAdmin);

  return (
    <div className='d-flex flex-column gap-4'>
      {isLoading ? <Loading /> : ''}
      <DateRangePicker
        label='Created Date'
        startDate={startDate}
        endDate={endDate}
        onChangeDates={onChangeShippedDates}
        required
      />
      {isAdmin && (
        <SelectSubAccountDropdown
          setSelectedSubAccount={onChangeAccount}
          selectedSubAccount={account}
          label='Account'
          firstOption='All Accounts'
        />
      )}
      <DropdownTemp
        id='carrier-mode-dropdown'
        options={carrierModes}
        value={carrierMode}
        setValue={onChangeCarrierMode}
        label='Carrier Mode'
      />
      <div className='d-flex flex-column gap-2 align-items-center pt-4'>
        <Button
          text='Download'
          onClick={onClickDownload}
          disabled={isLoading}
        />
        <Button
          text='Clear'
          onClick={clearFilters}
          disabled={isLoading}
        />
      </div>
    </div>
  );
}
